import colors from "./colors";
import typography from "./typography";

const styles = {
  colors,
  typography
};

export default styles;